
if (!Array.prototype.at) {
    Object.defineProperty(Array.prototype, 'at', {
        value: function(n) {
            n = Math.trunc(n) || 0;
            if (n < 0) n += this.length;
            if (n < 0 || n >= this.length) return undefined;
            return this[n];
        },
        writable: true,
        configurable: true,
        enumerable: false // Pastikan ini tidak enumerable
    });
}

// if(!window.structuredClone) {

//     window.structuredClone = (val) => JSON.parse(JSON.stringify(val));
// }